import React from 'react';

import { forwardRef } from '@chakra-ui/react';

import { warnDeprecated } from '../../helpers/deprecation';
import { resolveVersion } from '../../helpers/resolve-version';
import { TextProps, TextV21Props, TextV22Props } from './types';
import { TEXT_VERSIONS } from './versions';
import { TextV21 } from './versions/2.1/text';
import { TextV22 } from './versions/2.2/text';

export const Text = forwardRef<TextProps, 'p'>(function Text(
  { v, ...rest },
  ref
) {
  const version = resolveVersion(TEXT_VERSIONS, v);
  warnDeprecated(TEXT_VERSIONS, version, v);

  // Boundary casts: `v` is what discriminates `TextProps`, so destructuring it off leaves
  // `rest` holding the union of both versions' `size`. The branch above has already resolved
  // which version renders, which the type system cannot follow through `resolveVersion`.
  // Both branches stamp `data-dls-version`: the merged style-config keeps unstamped elements on
  // 2.1, because `Text` imported straight from `@chakra-ui/react` never reaches this dispatcher
  // and has to keep rendering the scale it always did.
  if (version === '2.1') {
    return (
      <TextV21 ref={ref} data-dls-version="2.1" {...(rest as TextV21Props)} />
    );
  }

  return (
    <TextV22 ref={ref} data-dls-version="2.2" {...(rest as TextV22Props)} />
  );
});

Text.displayName = 'Text';
